export const isSection = (item) => !!item && 'items' in item;
export const filterNodes = (contains) => (nodes) => Array.from(nodes)
    .map((item) => {
    if (!isSection(item.value) && item.value?.variant === 'none') {
        return item;
    }
    if (item.type === 'section') {
        return {
            ...item,
            childNodes: Array.from(item.childNodes).filter((node) => contains(node.textValue)),
        };
    }
    return contains(item.textValue) ? item : undefined;
})
    .filter(Boolean);
export const flattenItems = (items) => items.flatMap((item) => (isSection(item) ? item.items : [item]));
export const addVariantToItems = (items, selectionMode) => {
    const addVariant = (item) => ({
        ...item,
        variant: selectionMode === 'multiple' ? 'checkbox-item' : 'item',
    });
    return items.map((item) => {
        if (isSection(item)) {
            return {
                ...item,
                items: item.items.map(addVariant),
            };
        }
        return addVariant(item);
    });
};
export const sortItemsAlphanumerically = (cachedSelectedItems) => cachedSelectedItems.sort((itemA, itemB) => itemA.label.localeCompare(itemB.label, 'en', {
    sensitivity: 'accent',
}));
export const sortItemsBySelection = (items, cachedSelectedItems) => {
    const isItemNotSelected = ({ id }) => !cachedSelectedItems.find((selected) => selected.id === id);
    const itemsWithoutSelected = items.reduce((acc, item) => {
        if (isSection(item)) {
            return [...acc, { ...item, items: item.items.filter(isItemNotSelected) }];
        }
        return isItemNotSelected(item) ? [...acc, item] : acc;
    }, []);
    return [...cachedSelectedItems, ...itemsWithoutSelected];
};
const hasSelectItem = (collection) => Array.from(collection.getKeys()).some((key) => collection.getItem(key)?.type === 'item');
export const getNextItemKey = (currentKey, collection) => {
    if (!hasSelectItem(collection)) {
        return null;
    }
    let nextKey = currentKey;
    do {
        nextKey = collection.getKeyAfter(nextKey) || collection.getFirstKey();
    } while (nextKey && collection.getItem(nextKey)?.type !== 'item');
    return nextKey;
};
export const getPreviousItemKey = (currentKey, collection) => {
    if (!hasSelectItem(collection)) {
        return null;
    }
    let prevKey = currentKey;
    do {
        prevKey = collection.getKeyBefore(prevKey) || collection.getLastKey();
    } while (prevKey && collection.getItem(prevKey)?.type !== 'item');
    return prevKey;
};
export const findItemsByKeys = (...itemsArrays) => {
    const allItems = itemsArrays.reduce((prev, curr) => prev.concat(curr));
    return (keys) => Array.from(keys)
        .map((key) => allItems.find((item) => `${item.id}` === `${key}`))
        .filter((item) => item !== undefined);
};
//# sourceMappingURL=utils.js.map